<h1>Delete Confirmation</h1>
<h3 class="grey">Are you sure you want to delete this question?</h3>
<div class="floatright">
    <button mat-flat-button color="basic" [mat-dialog-close]>
        Cancel
    </button>
    <button mat-flat-button color="warn" [mat-dialog-close]="true" >
        Delete
    </button>
</div>